import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';
import { getMachineSettings } from './getMachineSettings';

/** Returns true when MES is enabled at both company and machine levels. */
export const getIsMESEnabled = createSelector(
  [getCompanySettings, getMachineSettings],
  (companySettings, machineSettings) => {
    return (
      companySettings?.mesEnabled === true &&
      machineSettings?.mesEnabled === true
    );
  }
);
